
export const COLORS = {
  tooltip: {
    background: 'rgba(0, 0, 0, 0.8)',
    text: '#fff',
  },
  white: '#fff',
  text: '#333',
  border: {
    donut: '#ffffff',
  },
  blue80: 'rgba(0, 123, 255, 0.8)',
  green80: 'rgba(40, 167, 69, 0.8)',
  yellow80: 'rgba(255, 193, 7, 0.8)',
  red80: 'rgba(220, 53, 69, 0.8)',
  black80: 'rgba(52, 58, 64, 0.8)',
  blue90: 'rgba(0, 123, 255, 0.9)',
  green90: 'rgba(40, 167, 69, 0.9)',
  yellow90: 'rgba(255, 193, 7, 0.9)',
  red90: 'rgba(220, 53, 69, 0.9)',
  black90: 'rgba(52, 58, 64, 0.9)',
} as const

export const CHART_COLOR_SCHEMES = {
  default: [
    COLORS.blue80,
    COLORS.green80,
    COLORS.yellow80,
    COLORS.red80,
    COLORS.black80,
  ],

  lifecycleStatus: [
    COLORS.green90,
    COLORS.blue90,
    COLORS.red90,
    COLORS.black90,
  ],

  operatingStatus: [
    COLORS.blue80,
    COLORS.green80,
    COLORS.yellow80,
    COLORS.red80,
    COLORS.black80,
  ],

  assetAge: [
    COLORS.green80,
    COLORS.blue80,
    COLORS.yellow80,
    COLORS.red80,
  ],
} as const

const LIFECYCLE_STATUS_COLOR_MAP: Record<string, string> = {
  active: COLORS.green90,
  classic: COLORS.blue90,
  limited: COLORS.red90,
  obsolete: COLORS.black90,
}

export function getColorsForData(variant: string, data: ReadonlyArray<{ name: string }>): string[] {
  const fallback = getColorsByVariant(variant)

  if (variant === 'lifecycleStatus') {
    return data.map((item, index) => {
      const key = (item.name || '').trim().toLowerCase()
      return LIFECYCLE_STATUS_COLOR_MAP[key] ?? fallback[index % fallback.length]
    })
  }

  return data.map((_, index) => fallback[index % fallback.length])
}

export function getColorsByVariant(variant: string): string[] {
  switch (variant) {
    case 'lifecycleStatus':
      return CHART_COLOR_SCHEMES.lifecycleStatus

    case 'operatingStatus':
      return CHART_COLOR_SCHEMES.operatingStatus

    case 'assetAge':
      return CHART_COLOR_SCHEMES.assetAge

    default:
      return CHART_COLOR_SCHEMES.default
  }
}

export const CHART_THEME = {
  colors: COLORS,
  colorSchemes: CHART_COLOR_SCHEMES,

  tooltip: {
    backgroundColor: COLORS.tooltip.background,
    titleColor: COLORS.tooltip.text,
    bodyColor: COLORS.tooltip.text,
  },

  text: {
    color: COLORS.text,
  },
} as const

export default CHART_THEME